<template>
    <div class="log-btn" :class="{'opened': logOpen}">
        <div class="title" @click="setLogOpen(true)">ЛОГ</div>
        <span class="i i-close" @click="setLogOpen(false)" v-if="logOpen"></span>
        <div class="log" v-if="logOpen && !isLoad">
            <div class="log__item text-center" v-if="items.length == 0">
                за {{dateLog}} ничего нет
            </div>
            <div class="log__item" v-for="item in items">
                <div class="top df df-space-between">
                    <div v-if="item.type == 'holiday'" class="event red">Взят отгул</div>
                    <div v-if="item.type == 'leave'" class="event red">− {{ item.time }}</div>
                    <div v-if="item.type == 'worked'" class="event green">+ {{ item.time }}</div>
                    <div v-if="item.type == 'converted_plus'" class="event green">+ 1 день</div>
                    <div v-if="item.type == 'converted_minus'" class="event red">- 1 день</div>
                    <div v-if="item.type == 'cancel'" class="event grey">Отменён отгул {{ item.time }}</div>
                    <div class="text-color-grey text-size-xs">
                        {{ item.date }}
                    </div>
                </div>
                <div class="comment mt8" v-if="item.type == 'holiday' && item.days &&  item.days.length > 0">
                    <span class="text-bold">{{ item.days.length }}&nbsp;дн: </span>
                    <span class="">{{ item.days.join('&nbsp;/ ') }}</span>
                </div>
                <div class="comment mt8">
                    <span class="text-bold">{{ item.workerName }}: </span>
                    <span class="">{{ item.comment }}</span>
                </div>
            </div>
            <div class="show-more" @click="getItems">
                Показать день раньше
            </div>

        </div>
        <div class="log --ghost" v-else-if="logOpen">
            <div class="log__item" v-for="i in 4">
                <div class="top df df-space-between">
                    <div class="event">
                    </div>
                    <div class="text-color-grey text-size-xs">
                    </div>
                </div>
                <div class="comment mt8">
                    <span class="text-bold"></span>
                </div>
            </div>
            <div class="show-more">
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "Log",
    data(){
        return {
            logOpen: false
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            items: state => state.log.items,
            isLoad: state => state.log.isLoad,
            dateLog: state => state.log.dateFormat,
        }),
    },
    methods: {
        getItems(){
            this.$store.dispatch('log/getItems');
        },
        setLogOpen(value){
            this.logOpen = value;
            if(value){
                this.$store.dispatch('log/getItems');
            } else {
                this.$store.commit('log/clear')
            }
        }
    },

}
</script>

<style scoped>

</style>